import { getRequestSign } from '../../tools/platformSign'
import { getPlatform } from '../../tools/getPlatform'
import axios from 'axios'

const $http = axios.create()
function getRunTime(str) {
  return str

  // let result
  // let _href = location.href.split('.')[0]
  // _href.replace(/-((box|qc)[0-9]*)/, (s, v) => {
  //   result = str.replace(/\./, `-${v}.`)
  // })
  //
  // if (!result) {
  //   result = str
  // }
  // return result
}

export function linkToAppStore(params) {
  const UA = navigator.userAgent
  const IS_IOS = /(iPhone|iPad|iPod|iOS)/i.test(UA)

  if (IS_IOS) {
    window.location.href =
      params.errIosUrl ||
      'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
  } else {
    window.location.href =
      params.errAndroidUrl ||
      `https://m.xinli001.com/download?utm_source=` + utmSource
  }
}
export function copyStr(str) {
  return new Promise(resolve => {
    let selection = window.getSelection()
    let range = document.createRange()
    let $code = document.createElement('div')
    $code.display = 'none'
    $code.innerHTML = str
    document.body.appendChild($code)

    range.selectNodeContents($code)
    selection.removeAllRanges()
    selection.addRange(range)

    document.execCommand('copy')
    selection = null
    range = null
    document.body.removeChild($code)
    resolve(true)
  })
}

export function handleCopyAndToApp(params, toAPP) {
  /* params = {
              object_id: '' ,//业务id,比如文章id
              title: '', //标题
              desc: '', //	描述
              url: ``, // 访问链接或协议
              type: '' // 业务类型 允许值: "article", "qa", "ceping", "lesson", "meditation", "fm", "act", "summit", "identity"
          }*/
  getCommandRequest(params).then(res => {
    if (res) {
      copyStr(res).then(() => {
        if (toAPP) {
          linkToAppStore(params)
        }
      })
    } else {
      if (toAPP) {
        linkToAppStore(params)
      }
    }
  })
}
let utmSource = ''
export function getCommandRequest({
  _version = '6.7.7',
  type = '',
  object_id = '',
  title = '',
  desc = '',
  url = '',
  utm_source = '',
  errIosUrl = '',
  errAndroidUrl = ''
} = {}) {
  const platform = getPlatform()
  let $platform = 'm'
  if (platform.isAndroid) {
    $platform = 'android'
  } else if (platform.isiPhone || platform.isiPad) {
    $platform = 'ios'
  } else if (platform.isPc) {
    $platform = 'pc'
  }
  if (platform.isYixinliApp) return
  return new Promise((resolve, reject) => {
    const baseParams = {
      _platform: $platform,
      _version: _version,
      type: type,
      object_id: object_id,
      title: title,
      desc: desc,
      url: url
    }
    const platFormSign = getRequestSign(baseParams)
    const newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
    const yiapiHost = getRunTime('//yiapi.xinli001.com')
    $http
      .get(yiapiHost + `/v6/yi/common/create-encode-command.json`, {
        params: newParams
      })
      .then(res => {
        utmSource = utm_source
        console.log('res', res)
        if (+res.data.code === 0) {
          resolve(res.data.data)
        } else {
          linkToAppStore({ errIosUrl, errAndroidUrl })
          reject()
        }
      })
  })
}

export function getShortUrl({
  _version = '6.7.7',
  remark = '',
  long_url = ''
} = {}) {
  const platform = getPlatform()
  let $platform = 'm'
  if (platform.isAndroid) {
    $platform = 'android'
  } else if (platform.isiPhone || platform.isiPad) {
    $platform = 'ios'
  } else if (platform.isPc) {
    $platform = 'pc'
  }
  return new Promise((resolve, reject) => {
    const baseParams = {
      _platform: $platform,
      _version: _version,
      remark,
      long_url,
      token: ''
    }
    const platFormSign = getRequestSign(baseParams)
    const newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
    const yiapiHost = getRunTime('//yiapi.xinli001.com')
    $http
      .post(yiapiHost + `/v7/yi/short-url-generate.json`, newParams)
      .then(res => {
        console.log('res', res)
        if (+res.data.code === 0 || +res.data.code === 20002) {
          resolve(res.data.data)
        } else {
          reject()
        }
      })
  })
}
